import {useDispatch, useSelector} from "react-redux";
import {getAdSize, OBJECT_CATEGORY, STORAGE_KEY} from "utils";
import {addAdBanner, addGUI, addObject} from "store/actions/asset";
import {getFullAssetUrl} from "utils";
import {ASSET_TYPE} from "components/Layout/constants";
import {changeAdUsedState} from "store/actions/ad";

function useAddAssetToScene() {
  const dispatch = useDispatch();
  const selectedSceneName = useSelector(state => state.asset.selectedSceneName);

  const saveRecentlyUsedAssets = asset => {
    const recentAssets = JSON.parse(localStorage.getItem(STORAGE_KEY.recentlyUsedAssets)) || [];

    if (recentAssets?.length >= 16) {
      recentAssets.pop();
    }

    const updatedAssets = recentAssets.filter(recentAsset => {
      return recentAsset.id !== asset.id;
    });

    updatedAssets.unshift(asset);

    localStorage.setItem(STORAGE_KEY.recentlyUsedAssets, JSON.stringify(updatedAssets));
  };

  const addGuiToScene = (name, url) => {
    dispatch(
      addGUI({
        category: OBJECT_CATEGORY.GUI,
        name: name,
        thumbnail: getFullAssetUrl(url),
      }),
    );
  };

  const adAddBannerToScene = (name, url, mimeType, thumbnailUrl) => {
    const isPngFile = mimeType === "png";

    if (isPngFile) {
      const size = getAdSize(url);
      dispatch(changeAdUsedState(size, true));

      dispatch(
        addAdBanner({
          category: OBJECT_CATEGORY.AD_BANNER,
          name: name,
          thumbnail: url,
          adInfo: JSON.stringify({size}),
        }),
      );
      return;
    }

    dispatch(
      addObject({
        category: OBJECT_CATEGORY.DEMO,
        name: name,
        object: url,
        thumbnail: thumbnailUrl,
      }),
    );
  };

  const addAssetToScene = async asset => {
    switch (asset.topCategory) {
      case "MODEL":
        handleModelAsset(asset);
        break;
      case "IMAGE":
        handleImageAsset(asset);
        break;
      default:
        break;
    }
  };

  const handleModelAsset = asset => {
    const assetUrl = getFullAssetUrl(asset.url);

    switch (asset.midCategory) {
      case ASSET_TYPE.AD_MODEL:
        adAddBannerToScene(asset.name, asset.url, asset.mimetype, asset.thumbnailUrl);
        break;
      case ASSET_TYPE.ASSET:
        dispatch(
          addObject({
            category: OBJECT_CATEGORY.DEMO,
            name: asset.name,
            object: assetUrl,
            thumbnail: asset.thumbnailUrl,
          }),
        );
        break;
      case ASSET_TYPE.MESH:
        dispatch(
          addObject({
            category: OBJECT_CATEGORY.MESH,
            name: asset.name.toUpperCase(),
            object: assetUrl,
            thumbnail: asset.thumbnailUrl,
          }),
        );
        break;
      case ASSET_TYPE.LIGHT:
        dispatch(
          addObject({
            scene: selectedSceneName,
            category: OBJECT_CATEGORY.LIGHT,
            name: asset.name.toUpperCase(),
            thumbnail: asset.thumbnailUrl,
          }),
        );
        break;
      case ASSET_TYPE.CAMERA:
        dispatch(
          addObject({
            category: OBJECT_CATEGORY.CAMERA,
            name: asset.name.toUpperCase(),
          }),
        );
        break;
      case ASSET_TYPE.SPAWN:
        switch (asset.name) {
          case ASSET_TYPE.STARTING_POINT:
            dispatch(
              addObject({
                scene: selectedSceneName,
                category: OBJECT_CATEGORY.STARTLOCATION,
                name: asset.name,
                object: assetUrl,
                thumbnail: asset.thumbnailUrl,
              }),
            );
            break;
          case ASSET_TYPE.PORTAL:
            dispatch(
              addObject({
                scene: selectedSceneName,
                category: OBJECT_CATEGORY.PORTAL,
                name: asset.name,
                thumbnail: asset.thumbnailUrl,
              }),
            );
            break;
          default:
            break;
        }
        break;
      default:
        dispatch(
          addObject({
            category: OBJECT_CATEGORY.DEMO,
            name: asset.name,
            object: assetUrl,
            thumbnail: asset.thumbnailUrl,
          }),
        );
        break;
    }
  };

  const handleImageAsset = asset => {
    const assetUrl = getFullAssetUrl(asset.url);

    switch (asset.midCategory) {
      case ASSET_TYPE.GUI:
        addGuiToScene(asset.name, asset.thumbnailUrl);
        break;
      case "TEXTURE":
        handleTexture(asset);
        break;
      default:
        dispatch(
          addObject({
            scene: selectedSceneName,
            category: OBJECT_CATEGORY.IMAGE,
            name: asset.name,
            object: assetUrl,
            thumbnail: asset.thumbnailUrl,
          }),
        );
        break;
    }
  };

  const handleTexture = asset => {
    const assetUrl = getFullAssetUrl(asset.url);

    switch (asset.subCategory) {
      case "PARTICLEMAP":
        dispatch(
          addObject({
            scene: selectedSceneName,
            category: OBJECT_CATEGORY.EFFECT,
            name: asset.name,
            object: assetUrl,
          }),
        );
        break;

      default:
        break;
    }
  };
  const onClickAsset = (asset, isUsedAsProperty) => {
    saveRecentlyUsedAssets(asset);
    addAssetToScene(asset, isUsedAsProperty);
  };

  return {addGuiToScene, onClickAsset};
}

export default useAddAssetToScene;
